import angular from 'angular';

angular.module('TALENYA-FE').controller('insightModalsCtrl', function ($scope, $uibModalInstance, insightCtrl ) {
    $scope.insightCtrl = insightCtrl;
    $scope.insightCtrl.$uibModalInstance = $uibModalInstance;
});